import moment from 'moment';
import { getUTCStartOfDate } from '../../utils/date-utils';

export default function(formData: any) {
  const {
    gender,
    name,
    countryCode,
    startingCode,
    number: phoneNumber,
    email,
    password,
    gearType,
    licenseTypeId,
    licenseTypeCategory,
    language,
    nationality,
    hasResidencyVisa,
    dob,
    whatsAppPhone,
    isThroughReference,
    refererPhoneNumber,
    emiratesId,
    emiratesIdExpiry
  } = formData;

  const finalData = {
    gender,
    name,
    email,
    password,
    nationality,
    dob: getUTCStartOfDate(dob),
    phones: {
      firstNumber: {
        countryCode,
        startingCode,
        numberType: 'home',
        number: phoneNumber.toString(),
        NumberCode: `${countryCode}${startingCode}${phoneNumber}`,
        isPrimary: true,
      },
    },
    studentDetails: {
      gearType,
      language,
      hasResidencyVisa,
      requiredLicenseId: licenseTypeId,
      requiredLicenseCategory: licenseTypeCategory,
      emiratesId,
      emiratesIdDetails:{}
    },
    whatsAppPhone,
    isThroughReference,
    refererPhoneNumber
  };
  
  if(!finalData.isThroughReference){
    delete finalData.refererPhoneNumber  
  }

    if (emiratesId) {
       finalData.studentDetails.emiratesId = emiratesId;
      finalData.studentDetails.emiratesIdDetails = {
        id: emiratesId,
        expiryDate:moment(emiratesIdExpiry).format("DD/MM/YYYY")
    };
    }

  return finalData;
}


